"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardMarkAsReadOption_1 = require("./actions/discardMarkAsReadOption");
var saveMarkAsReadOption_1 = require("./actions/saveMarkAsReadOption");
var MarkAsReadFull_1 = require("./components/MarkAsReadFull");
var isMarkAsReadOptionDirty_1 = require("./utils/isMarkAsReadOptionDirty");
var React = require("react");
var MarkAsReadOption = {
    key: 'markAsRead',
    titleStringKey: 'optionTitle_markAsRead',
    searchTermsStringKey: 'optionTitle_markAsRead',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MarkAsReadFull_1.default, null); },
        isDirty: isMarkAsReadOptionDirty_1.default,
        onSave: saveMarkAsReadOption_1.default,
        onDiscard: discardMarkAsReadOption_1.default,
    },
};
exports.default = MarkAsReadOption;
//# sourceMappingURL=MarkAsReadOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/MarkAsReadOption.js
// module id = 5040
// module chunks = 2